import { useTranslation } from 'next-i18next'

import appConfig from '~/config/app'
import useFileBlob from '~/shared/hooks/useFileBlob'
import { ButtonPrimary } from '~/components/Buttons'
import { MediabankAsset } from '~/types/media'
import { last } from '~/utils'
import ResponsiveImage from '~/components/Image/ResponsiveImage'
import SVGIcon from '~/components/Icons/svgs/SVGIcon'
import DownloadIcon from '~/components/Icons/svgs/DownloadIcon'

export default function MediaMediabankDetail({ asset }: { asset: MediabankAsset }): React.ReactElement {
  const { t } = useTranslation('media')

  const assetUrl = `${appConfig.assetsCdnUrl}/${asset.image.srcKey}`
  const { blobUrl, filename } = useFileBlob(assetUrl)
  const fileFormat = last(filename.split('.'))
  const mediaQuery = [{ screen: '(min-width: 280px)', width: `${asset.image.width}px` }]

  return (
    <div className="max-w-max mx-auto">
      <div>
        <div className={`p-5 rounded ${asset.bgStyle === 'dark' ? 'bg-black-light' : ''}`}>
          <ResponsiveImage
            alt={asset.image.alt}
            className="mx-auto"
            height={asset.image.height}
            imageWidths={`${asset.image.width}`}
            mediaQuery={mediaQuery}
            srcKey={asset.image.srcKey as string}
            width={asset.image.width}
          />
        </div>

        <div className="mt-4 text-xs font-medium">{asset.type}</div>
        <div className="mt-2 text-md font-semibold">{asset.title}</div>
        <ul className="list-disc list-outside mt-1 pl-4 space-y-1 text-xs">
          <li>{t('license', { license: asset.license })}</li>
          <li>{t('credit', { credit: asset.credit })}</li>
          <li>{t('fileFormat', { fileFormat })}</li>
        </ul>
      </div>

      <ButtonPrimary className="mt-4" download={filename} href={blobUrl} size="small">
        <SVGIcon icon={DownloadIcon} pathClassName="currentColor" />
        <span>{t('download')}</span>
      </ButtonPrimary>
    </div>
  )
}
